module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_0_0.b60fcd1b.png";